import app from './app'
import kansas from './kansas'
import texas from './texas'
import navigation from './navigation'
import externalUrls from './externalUrls'
import customCookies from './customCookies'
import externalWalletParams from './externalWalletParams'

export default {
  app,
  kansas,
  texas,
  navigation,
  externalUrls,
  customCookies,
  externalWalletParams
}



// WEBPACK FOOTER //
// ./src/config/index.js